import { generateBaseQueryKeysList } from '@/queries/utils';
import { BASE_QUERY_KEYS } from '@/queries/consts';

export const MULTI_SUGGEST_KEYS = {
  main: 'multi-suggest',
  candidates: 'candidates',
  reviews: 'reviews',
  chain: 'chain',
};

export const multiSuggestKeys = {
  ...generateBaseQueryKeysList(MULTI_SUGGEST_KEYS.main),
  getCandidates: (...args: unknown[]) => [MULTI_SUGGEST_KEYS.main, MULTI_SUGGEST_KEYS.candidates, ...args] as const,
  getMultiSuggestResultItem: (taskId: string = '', ...args: unknown[]) => [
    MULTI_SUGGEST_KEYS.main,
    BASE_QUERY_KEYS.item,
    `taskId:${taskId}`,
    ...args,
  ],
  getReviews: (id: string, ...args: unknown[]) =>
    [...multiSuggestKeys.getMultiSuggestResultItem(id), MULTI_SUGGEST_KEYS.reviews, ...args] as const,
  getMultiSuggestCaseResultByChain: (taskId: string, chainIndex: number, ...args: unknown[]) => [
    MULTI_SUGGEST_KEYS.main,
    BASE_QUERY_KEYS.item,
    `taskId:${taskId}`,
    MULTI_SUGGEST_KEYS.chain,
    `chainIndex:${chainIndex}`,
    ...args,
  ],
  getMultiSuggestCaseResultByCase: (taskId: string, chainIndex: number, caseId: string, ...args: unknown[]) => [
    ...multiSuggestKeys.getMultiSuggestCaseResultByChain(taskId, chainIndex),
    `caseId:${caseId}`,
    ...args,
  ],
};
